import { useEffect, useState } from 'react';
import useRouter from '../../../utils/useRouter';
import { LicenceModel } from '@kimuno/api-sdk/lib/types/responses/Billing';
import { routes } from '../../../constants';
import getReplacementLicence from '../../../utils/replacementLicence';

interface UseLicenceModelProps {
  licenceModels: { [key: string]: LicenceModel };
  urlLicenceId: number;
  isLibraryReady: boolean;
  hasValidLibraryIp: boolean;
}

const useLicenceModel = ({ licenceModels, urlLicenceId, isLibraryReady, hasValidLibraryIp }: UseLicenceModelProps) => {
  const { match: { location: { query, pathname } }, router } = useRouter();
  const [selectedLicenceModel, setSelectedLicenceModel] = useState<LicenceModel>(licenceModels[urlLicenceId]);
  const [traineeLicenceModel, setTraineeLicenceModel] = useState<LicenceModel>();

  useEffect(() => {
    if (Object.keys(licenceModels).length) {
      const licence = licenceModels[urlLicenceId];
      const validLicenceIfLibrary = !isLibraryReady || (!!licence?.isLibrary === hasValidLibraryIp);
      if (licence && validLicenceIfLibrary) {
        setSelectedLicenceModel(licence);
        if (licence?.alternativeOfferId) {
          setTraineeLicenceModel(licenceModels[licence.alternativeOfferId]);
        }
      } else {
        const replacementLicence = getReplacementLicence(licenceModels, urlLicenceId);
        if (replacementLicence) {
          router.replace({
            pathname,
            query: { ...query, licenceId: replacementLicence.licenceModelId.toString() }
          });
        } else if (isLibraryReady) {
          router.replace(`/${routes.notFound.root}`);
        }
      }
    }
  }, [licenceModels, urlLicenceId, isLibraryReady, hasValidLibraryIp, pathname, query, router]);

  const toggleSelectedLicenceModel = () => {
    const licence = licenceModels[urlLicenceId];

    if (!traineeLicenceModel || !licence.isTrial) return;
    const isTrialLicenceSelected = selectedLicenceModel?.licenceModelId !== licence.licenceModelId;
    setSelectedLicenceModel(isTrialLicenceSelected ? licence : traineeLicenceModel);
  };

  return { selectedLicenceModel, traineeLicenceModel, toggleSelectedLicenceModel };
};

export default useLicenceModel;
